export default function Node_Frontend() {
  return <div>Node_Frontend Component</div>;
}
